/**
 * components/Drawer/DrawerSection
 * One full-bleed block inside the ledger drawer: `16px 18px` padding and a
 * bottom rule that reaches both panel edges. An optional eyebrow opens it
 * ("POSITION", "RECORD A TRANSACTION", "TRANSACTION LEDGER · APPEND-ONLY").
 */
import type { ReactNode } from 'react';
import { StyleSheet, View } from 'react-native';
import { neutral } from '../../theme/colors';
import Eyebrow from '../Eyebrow';

export interface DrawerSectionProps {
  eyebrow?: string;
  children: ReactNode;
  /** Off for the last section, which needs no closing rule. */
  divided?: boolean;
  /** The gap between the eyebrow and the content. */
  gap?: number;
}

export function DrawerSection({
  eyebrow,
  children,
  divided = true,
  gap = 8,
}: DrawerSectionProps) {
  return (
    <View style={[styles.section, { gap }, divided && styles.divided]}>
      {!!eyebrow && <Eyebrow dark>{eyebrow}</Eyebrow>}
      {children}
    </View>
  );
}

const styles = StyleSheet.create({
  section: { paddingVertical: 16, paddingHorizontal: 18 },
  divided: { borderBottomWidth: 1, borderBottomColor: neutral.border },
});

export default DrawerSection;
